module.exports = __webpack_public_path__ + "img/IMG_9519_L_WoodMatted_MockedUp.df0edaf8.jpg";